import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { ProductImageRenditions } from "@omni/types/components/product/productImageRenditions.type";

// Call To Action List
export const CTAListRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.MINI,
    xs: ProductImageRendition.MINI,
    sm: ProductImageRendition.MINI,
    md: ProductImageRendition.MINI,
    lg: ProductImageRendition.MINI,
    xl: ProductImageRendition.MINI
};

export const GiftCardRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.SM,
    xs: ProductImageRendition.MD,
    sm: ProductImageRendition.MD,
    md: ProductImageRendition.SM,
    lg: ProductImageRendition.SM,
    xl: ProductImageRendition.SM
};

// Shopping Cart Items on page
export const ShoppingCartItemRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.MINI,
    xs: ProductImageRendition.MINI,
    sm: ProductImageRendition.XS,
    md: ProductImageRendition.XS,
    lg: ProductImageRendition.MINI,
    xl: ProductImageRendition.XS
};

// Shopping Cart Dropdown
export const ShoppingCartSummaryRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.MINI,
    xs: ProductImageRendition.MINI,
    sm: ProductImageRendition.MINI,
    md: ProductImageRendition.SM,
    lg: ProductImageRendition.MINI,
    xl: ProductImageRendition.MINI
};

// Add To Cart Model
export const AddToCartModelRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.XS,
    xs: ProductImageRendition.SM,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.SM,
    lg: ProductImageRendition.SM,
    xl: ProductImageRendition.SM
};

// Order Confirmation Page
export const OrderOverviewItemRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.MINI,
    xs: ProductImageRendition.MINI,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.XS,
    lg: ProductImageRendition.MINI,
    xl: ProductImageRendition.XS
};

// My Orders Page
export const OrderItemRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.MINI,
    xs: ProductImageRendition.XS,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.MINI,
    lg: ProductImageRendition.MINI,
    xl: ProductImageRendition.XS
};

// My Order Detail Page
export const OrderDetailItemRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.XS,
    xs: ProductImageRendition.SM,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.XS,
    lg: ProductImageRendition.XS,
    xl: ProductImageRendition.SM
};

// ProductSliders
export const ProductSlidersRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.SM,
    xs: ProductImageRendition.SM,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.SM,
    lg: ProductImageRendition.SM,
    xl: ProductImageRendition.SM
};

// Configurable product only has 1 rendition so these values are just fixed
export const ConfigurableProductRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.SM,
    xs: ProductImageRendition.SM,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.SM,
    lg: ProductImageRendition.SM,
    xl: ProductImageRendition.SM
};

// ProductTile
export const ProductTileRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.MD,
    xs: ProductImageRendition.MD,
    sm: ProductImageRendition.MD,
    md: ProductImageRendition.MD,
    lg: ProductImageRendition.MD,
    xl: ProductImageRendition.MD
};

// ProductSearchTile
export const ProductSearchTileRenditions: ProductImageRenditions = {
    defaultRendition: ProductImageRendition.SM,
    xs: ProductImageRendition.XS,
    sm: ProductImageRendition.SM,
    md: ProductImageRendition.SM,
    lg: ProductImageRendition.SM,
    xl: ProductImageRendition.SM
};
